import { render, staticRenderFns } from "./CPaymentConfig.vue?vue&type=template&id=91edda5e&"
import script from "./CPaymentConfig.vue?vue&type=script&lang=js&"
export * from "./CPaymentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports